import React from "react";
import { StyledTitleWithFetchData } from "../../../styled/labels";

const titleWithFetchData = ({ title, noRefresh, fetchData }) => {
  return (
    <StyledTitleWithFetchData.Container>
      <StyledTitleWithFetchData.Title variant="h6">
        {title}
      </StyledTitleWithFetchData.Title>
      {!noRefresh && fetchData && (
        <StyledTitleWithFetchData.StyledLoopIcon onClick={fetchData} />
      )}
    </StyledTitleWithFetchData.Container>
  );
};

export default titleWithFetchData;
